import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from 'react-router-dom';
import { BASE_PATH, IS_REVIEW } from '../../../constants';
import { PreviewScreen } from '../pages/PreviewScreen/PreviewScreen';
import { PrototypeScreen } from '../pages/PrototypeScreen/PrototypeScreen';
import { ThankYouScreen } from '../pages/ThankYouScreen/ThankYouScreen';
import { UnmoderatedScreen } from '../pages/UnmoderatedScreen/UnmoderatedScreen';
import { routes } from './index';

const QueryParamBasedComponent = () => {
  const [searchParams] = useSearchParams();

  const path = searchParams.get('path');

  switch (path) {
    case 'preview':
      return <PreviewScreen />;
    case 'thank-you':
      return <ThankYouScreen />;
    case 'prototype':
      return <PrototypeScreen />;
    case 'pre-check':
    default:
      return <UnmoderatedScreen />;
  }
};

export const AppRoutes = () => {
  if (IS_REVIEW) {
    return (
      <BrowserRouter basename={BASE_PATH}>
        <Routes>
          <Route path={'/index.html'} element={<QueryParamBasedComponent />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter basename={BASE_PATH}>
      <Routes>
        <Route index element={<Navigate to={routes.PRE_CHECK.getPath(window.location.search)} />} />
        <Route path={routes.PRE_CHECK.getPath()} element={<UnmoderatedScreen />} />
        <Route path={routes.PREVIEW.getPath()} element={<PreviewScreen />} />
        <Route path={routes.THANK_YOU.getPath()} element={<ThankYouScreen />} />
        <Route path={routes.PROTOTYPE_RENDER.getPath()} element={<PrototypeScreen />} />
      </Routes>
    </BrowserRouter>
  );
};
